import { ItemTypeIcon } from '@/components/ui/item-type/itemTypeIcon';
import type { ItemTypeMap } from '@/lib/api/types/itemType';

interface ItemInlineChipProps {
  name: string;
  itemTypeId: number;
  itemTypesById: ItemTypeMap;
}

export const ItemInlineChip = ({ name, itemTypeId, itemTypesById }: ItemInlineChipProps) => {
  const itemType = itemTypesById[itemTypeId];
  return (
    <span className="flex items-center gap-2 text-sm min-w-0">
      {itemType && <ItemTypeIcon itemType={itemType} />}
      <span className="truncate">{name}</span>
    </span>
  );
};
